import { useCallback, useEffect, useState } from 'react';
import { path } from 'ramda';
import uuid from 'uuid-random';

import { useTranslations } from 'js/hooks/i18n';
import { useUserSelector } from '@core/js/store/hooks';

const categories = ['new', 'recommended', 'popular'];

export const useGetVaixGames = () => {
  const [vaixGames, setVaixGames] = useState([]);
  const userId = useUserSelector(path(['userDetails', 'userId']));
  const translate = useTranslations('playtech.mobile.system.vaixGames.categories.');

  const getVaixGameCategory = useCallback(async (category) => {
    const myHeaders = new Headers();
    myHeaders.append('Authorization', 'Bearer a07d75a3b5d072acd1af80e605db789f90e5a3779efbfbf5599a54e77aa6c5ec');
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('x-vaix-client-id', 'betparx_casino');

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    try {
      const location = category === 'popular' ? 'top_ten_region' : 'base';
      const apiUrl = `https://api.vaix.ai/api/casino/games/${category}?user=${userId || 0}&location=${location}`;

      const response = await fetch(apiUrl, requestOptions);
      const result = await response.json();
      return {
        category,
        games: result?.data.map((game) => game.game_id) || []
      };
    } catch (error) {
      console.error(error);
    }
  }, [userId]);

  useEffect(() => {
    const fetchGames = async () => {
      const results = await Promise.all(categories.map((c) => getVaixGameCategory(c)));
      const filteredResults = results.filter(Boolean);
      setVaixGames(
        filteredResults.map(({ category, games }) => ({
          liveLaunchAliases: [],
          cid: uuid(),
          displayName: translate(category),
          displayNameShort: category,
          name: category,
          gameCodes: games,
          pgg2: { enabled: true, maxGames: 20, minGames: 5 }
        }))
      );
    };

    fetchGames();
  }, [getVaixGameCategory, translate]);

  return vaixGames;
};
